import { IFourVariantXP } from "@faire/web-api--source/indigofair/settings/IFourVariantXP";
import { experiment } from "@faire/web/common/settings/declarations/experiment";

/**
 * Builder XP with four variants
 */
export const FE_BUILDER_XP_WITH_FOUR_VARIANTS_250306 = experiment({
  name: "FE_BUILDER_XP_WITH_FOUR_VARIANTS_250306",
  identifier: "RetailerTokenOrLoggedOutSessionToken",
  client: ["RETAILER", "VISITOR_WEB"],
  notifyAfter: "2025-03-06",
  defaultValue: IFourVariantXP.Bucket.CONTROL,
  productArea: "LOGGED_OUT_RETAILERS",
});
